module.exports = __webpack_public_path__ + "static/media/medal.787aa4fe.svg";